import { map, filter } from 'lodash';
import styled from 'styled-components';

import { FormStatus } from '@simplifidev/shared/dist/constants/forms';

import DownloadFile, {
  DownloadFileDisabled,
} from 'components/buttons/DownloadFile';
import { useFormDownloadURL } from 'state/server/forms';

const displayName = {
  idr: 'IDR',
  pslf: 'PSLF',
  consolidation: 'Consolidation',
};

const downloadReadyStatuses = [
  FormStatus.SIGNED,
  FormStatus.PROCESSED,
  FormStatus.COMPLETED,
];

/**
 * A form download link.
 *
 * @param {{
 *  formType: keyof displayName;
 *  formId: string;
 *  documentId: string;
 * }} params
 */
const DownloadLink = ({ formType, formId, documentId }: any) => {
  const { mutate, isPending } = useFormDownloadURL();
  const name = (displayName as any)[formType];

  const handleClick = () => {
    mutate(
      { formId: formId.toString(), documentId },
      {
        onSuccess: data => {
          if (data?.fileUrl) {
            window.open(data.fileUrl, '_blank', 'noopener,noreferrer');
          }
        },
      },
    );
  };

  return (
    <DownloadFile
      isLoading={isPending}
      onClick={handleClick}
      displayName={name}
      disabled={false}
    />
  );
};

const FormDownload = ({ form }: any) => {
  const { signRequests, id: formId, formType, status: formStatus } = form;

  const completedBorrowerSignRequests = filter(signRequests, {
    complete: true,
    role: 'borrower',
  });

  const formIsReadyToDownload =
    downloadReadyStatuses.includes(formStatus) &&
    signRequests.every((sr: any) => sr.documentId);

  return (
    <FormDownloadContainer>
      {formIsReadyToDownload ? (
        map(completedBorrowerSignRequests, ({ formType, documentId }) => (
          <DownloadLink
            key={documentId}
            formType={formType}
            formId={formId}
            documentId={documentId}
          />
        ))
      ) : (
        <DownloadFileDisabled displayName={(displayName as any)[formType]} />
      )}
    </FormDownloadContainer>
  );
};

const FormDownloadContainer = styled.div`
  text-align: right;

  .text {
    display: block;

    &:not(:first-child) {
      margin-top: 8px;
    }
  }
`;

export default FormDownload;
